import { Component } from '@angular/core';

@Component({
  selector: 'app-wizard',
  templateUrl: './wizard.component.html',
})
export class WizardComponent {
  steps = [
    {
      index: 1,
      title: 'Brainstorming',
    },

    {
      index: 2,
      title: 'Getting Started',
    },

    {
      index: 3,
      title: 'Photo Upload',
    },

    {
      index: 4,
      title: 'Storywritting',
    },

    {
      index: 5,
      title: 'Detailing',
    },

    {
      index: 6,
      title: 'Audio',
    },

    {
      index: 7,
      title: 'Publishing',
    },
  ];

  currentStep = 0;

  previousStep() {
    if (this.currentStep > 0) {
      window.scrollTo(0, 0);
      this.currentStep--;
    }
  }

  nextStep() {
    if (this.currentStep < this.steps.length - 1) {
      window.scrollTo(0, 0);
      this.currentStep++;
    }
  }
}
